module.exports = __webpack_public_path__ + "img/marshall-island.aa0f484f.svg";